import React from 'react';
import { MdWarning } from 'react-icons/md';

const DeactivateUserModal = ({
  open,
  deletingUserId,
  users,
  error,
  message,
  loading,
  onClose,
  onConfirmDeactivate,
}) => {
  if (!open || !deletingUserId) return null;

  const userEmail = users.find((u) => u.id === deletingUserId)?.email;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        backdropFilter: 'blur(6px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        zIndex: 999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: '500px',
          background: '#fff',
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
          overflow: 'hidden',
          transform: 'scale(1)',
        }}
      >
        {/* HEADER */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '20px',
            borderBottom: '1px solid #eee',
            position: 'relative',
          }}
        >
          <div
            style={{
              background: '#fee2e2',
              color: '#dc2626',
              padding: '10px',
              borderRadius: '10px',
              fontSize: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdWarning />
          </div>

          <div>
            <h3 style={{ margin: 0, fontSize: '18px' }}>Deactivate User</h3>
            <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#666' }}>
              Account will be locked temporarily
            </p>
          </div>

          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              right: '15px',
              top: '15px',
              border: 'none',
              background: 'none',
              fontSize: '16px',
              cursor: 'pointer',
            }}
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div style={{ padding: '20px' }}>
          {error && (
            <div
              style={{
                background: '#fee2e2',
                color: '#b91c1c',
                padding: '10px',
                borderRadius: '8px',
                marginBottom: '10px',
              }}
            >
              {error}
            </div>
          )}

          {message && (
            <div
              style={{
                background: '#dcfce7',
                color: '#166534',
                padding: '10px',
                borderRadius: '8px',
                marginBottom: '10px',
              }}
            >
              {message}
            </div>
          )}

          <div
            style={{
              background: '#fff7ed',
              border: '1px solid #fdba74',
              padding: '12px',
              borderRadius: '10px',
              marginBottom: '16px',
            }}
          >
            <strong>This account will be locked</strong>
            <p style={{ margin: '4px 0 0', fontSize: '13px' }}>
              User won’t be able to login until reactivated.
            </p>
          </div>

          <div
            style={{
              background: '#f1f5f9',
              padding: '12px',
              borderRadius: '10px',
              marginBottom: '16px',
            }}
          >
            <span style={{ display: 'block', fontSize: '12px', color: '#666' }}>
              Selected user
            </span>
            <strong>{userEmail}</strong>
          </div>

          <div>
            <p style={{ fontWeight: 600, marginBottom: '8px' }}>
              What happens next:
            </p>
            <ul style={{ paddingLeft: '18px', color: '#555', margin: 0 }}>
              <li>Data remains safe</li>
              <li>Login access is blocked</li>
              <li>You can reactivate anytime</li>
            </ul>
          </div>
        </div>

        {/* FOOTER */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px',
            padding: '15px 20px',
            borderTop: '1px solid #eee',
          }}
        >
          <button
            onClick={onClose}
            disabled={loading}
            style={{
              padding: '8px 14px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              background: '#fff',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>

          <button
            onClick={() => onConfirmDeactivate(deletingUserId)}
            disabled={loading}
            style={{
              padding: '8px 14px',
              borderRadius: '8px',
              border: 'none',
              background: '#dc2626',
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            {loading ? 'Deactivating...' : 'Deactivate'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateUserModal;